import { useSelector } from 'react-redux';
import adminSelectors from 'store/admin/selectors';
import { useTranslation } from 'react-i18next';

const useUserGroupsNames = () => {
  const { t } = useTranslation();
  const userGroups = useSelector(adminSelectors.usergroups.getGroups);

  const getNames = (groupsIds: string[]): string[] => {
    const idSet = new Set(groupsIds.map((v) => String(v)));
    const groups = userGroups
      ?.filter((group) => idSet.has(group.uid))
      .map((group) => group.name + (group.enabled ? '' : ` ${t('group.disabled')}`));

    return groups || [];
  };

  return {
    getUserGroupsNames: getNames,
  };
};

export { useUserGroupsNames };
